import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import OrderFontList from '../entities/order-font-list'
import createdata from '@/store/entities/create-order'
import appconst from '@/lib/appconst';
import UserOrderStatistics from '@/store/entities/user-order-statistics';


interface FontOrderState extends ListState<OrderFontList> {
    orderInfo: createdata,

}

class FontOrderMutations extends ListMutations<OrderFontList>{

}
class FontAbroadOrder extends ListModule<FontOrderState, any, OrderFontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OrderFontList>(),
        loading: false,
        orderInfo: new createdata(),
        orderStatus: null
    }
    actions = {
        async getAll(context: ActionContext<FontOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontAbroadOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OrderFontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async createOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadOrder/CreateOrder', payload.data);
        },
        async updateOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadOrder/UpdateOrder', payload.data);
        },
        async cancelOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadOrder/CancleOrder?orderId=' + payload.data.orderId);
        },
        async normalOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadOrder/NormalOrder?id=' + payload.data.id);
        },
        async getOrder(context: ActionContext<FontOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontAbroadOrder/GetOrderInfo?id=' + payload.data.id);
            context.state.orderInfo = (reponse.data.result as createdata);
        },

    };
    mutations = {
        setCurrentPage(state: FontOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getPdf(state: FontOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber);
            }
        }
    }
}

const fontabroadOrder = new FontAbroadOrder();
export default fontabroadOrder;